import { FETCH_MAINTENANCES, LOG_OUT_USER } from "../../actions/actionTypes";

const fetchMaintenanceSummaryReducer = (summary, payload) => {
    summary = [];
    for(let s of payload){
        summary.push(s);
    }
    return summary;
}


const maintenanceSummaryReducer = (state=[], action) => {
    let summary = state;
    if (action && action.summary && !action.payload.errors){
        switch(action.type){
            case FETCH_MAINTENANCES:
                return fetchMaintenanceSummaryReducer(summary, action.summary);
            case LOG_OUT_USER:
                return [];
            default:
                return summary;
        }
    }
    return summary;
}

export default maintenanceSummaryReducer;